<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >


        <el-form-item

        >
          <el-input
                  v-model="searchForm.order_id"
                  placeholder="订单号"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="datetimerange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.is_qr"
                  placeholder="收货状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item

        >
          <el-input
                  v-model="searchForm.express_no"
                  placeholder="快递号"
                  style="width: 100px;"
          />
        </el-form-item>
<!--
        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.is_sale"
                  placeholder="售卖状态"
                  width="50"
          >
            <el-option
                    v-for="item in saleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
-->
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>


        <el-form-item>
          <el-button
                  type="primary"
                  @click="handleExportFormSubmit"
          >
            <d2-icon name="share" /> 导出
          </el-button>
        </el-form-item>

      </el-form>
    </template>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
              label="订单号"
      >
        <template slot-scope="scope">
          {{scope.row.order_id}}
        </template>
      </el-table-column>
      <el-table-column
              label="支付订单号"
      >
        <template slot-scope="scope">
          {{scope.row.pay_order_id}}
        </template>
      </el-table-column>

      <el-table-column
              label="用户名称"
      >
        <template slot-scope="scope">
          {{scope.row.user_name}}
        </template>
      </el-table-column>
      <el-table-column
              label="用户头像"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.user_img_url!=null && scope.row.user_img_url!=''">
            <img :src= "getImgUrl2(scope.row)" style="width: 100px;height: 100px; "/>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="订单金额"
      >
        <template slot-scope="scope">
          {{scope.row.amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="下单时间"
      >
        <template slot-scope="scope">
          {{scope.row.insert_time2}}
        </template>
      </el-table-column>
      <el-table-column
              label="支付状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.stat==0">
            未支付
          </div>
          <div v-else-if="scope.row.stat==1">
            已支付
          </div>
          <div v-else-if="scope.row.stat==2">
            支付失败
          </div>
        </template>
      </el-table-column>
      <!--
      <el-table-column
              label="是否团长"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.is_chief==0">
            是
          </div>
          <div v-else-if="scope.row.is_chief==1">
            否
          </div>

        </template>
      </el-table-column>

      <el-table-column
              label="是否中奖"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.stat_order==1 || scope.row.stat_order==2">
            <div v-if="scope.row.is_win==0">
              未中奖
            </div>
            <div v-else-if="scope.row.is_win==1">
              已中奖
            </div>
          </div>
        </template>
      </el-table-column>
-->

      <el-table-column
              label="商品名称"
      >
        <template slot-scope="scope">

          {{scope.row.good_name}}
        </template>
      </el-table-column>

      <el-table-column
              label="商品图片"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.good_url!=null && scope.row.good_url!=''">



            <span v-for="(item,index) in scope.row.good_url.split(',')">
              <span v-if="index==0">
                 <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl(scope.row)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 100px; "></video>
              </span>
              <span v-else>
                 <img :src= "getImgUrl(scope.row)" style="width: 200px;height: 100px; "/>
              </span>
              </span>
          </span>


          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="收件人"
      >
        <template slot-scope="scope">

          {{scope.row.consignee}}
        </template>
      </el-table-column>

      <el-table-column
              label="收货人电话"
      >
        <template slot-scope="scope">

          {{scope.row.consignee_tel}}
        </template>
      </el-table-column>

      <el-table-column
              label="收货人地址"
      >
        <template slot-scope="scope">

          {{scope.row.province_address}}{{scope.row.consignee_address}}
        </template>
      </el-table-column>

      <el-table-column
              label="快递名称"
      >
        <template slot-scope="scope">

          {{scope.row.express_name}}
        </template>
      </el-table-column>

      <el-table-column
              label="快递单号"
              width="150"
      >
        <template slot-scope="scope">


          <div v-if="scope.row.express_no!=null && scope.row.express_no!=''">
            <div    @click="aaaa()">{{scope.row.express_no}}</div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.is_qr==0 && scope.row.stat==1">
            <div v-if="scope.row.stat_order==0">
              拼团中
            </div>
            <div v-if="scope.row.stat_order==1 || scope.row.stat_order==2">
              已退款
            </div>
          </div>
          <div v-else-if="scope.row.is_qr==1">
            已收货
          </div>
          <div v-else-if="scope.row.is_qr==2">
            待发货
          </div>
          <div v-else-if="scope.row.is_qr==3">
            待收货
          </div>

        </template>
      </el-table-column>
      <!--
      <el-table-column
              label="参团人员"
      >
        <template slot-scope="scope">

         {{scope.row.group_num}}
        </template>
      </el-table-column>

      <el-table-column
              label="允许寄售时间"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.group_num==10 || scope.row.group_num==20">  {{scope.row.sale_end_times}}</div>
        </template>
      </el-table-column>

      <el-table-column
              label="售卖状态"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.stat_order==1">

            <div v-if="scope.row.group_num==10 || scope.row.group_num==20">

            <div v-if="scope.row.is_win==1">
              <div v-if="scope.row.is_sale==0">

                <div v-if="new Date().getTime()>new Date(scope.row.sale_end_times).getTime()">
                  寄售结束
                </div>
                <div v-else>
                  待寄售
                </div>
              </div>
              <div v-else-if="scope.row.is_sale==1">


                <div v-if="scope.row.sale_order_id==''">
                  寄售中
                </div>
                <div v-else-if="scope.row.sale_order_id!=''">
                  售卖成功，订单号：{{scope.row.sale_order_id}}
                </div>

              </div>


            </div>



            </div>


            <div v-else>
              禁止寄售
            </div>



          </div>


        </template>
      </el-table-column>
-->

      <el-table-column
              fixed="right"
              label="操作"
              align="center"
              width="150"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"     v-if="scope.row.is_sale==0"  @click="openEditForm(scope.row)">快递编辑</el-button>
          <!-- <el-button type="primary" plain  size="mini"     v-if="scope.row.is_sale==1 && scope.row.sale_order_id==''"  @click="openViewForm3(scope.row)">关联买家订单</el-button>-->
          <!-- <el-button type="primary" plain  size="mini"      @click="openViewForm2(scope.row)">查看买家订单</el-button>-->
     </template>
   </el-table-column>



 </el-table>
 <template slot="footer">
   <el-pagination
     :current-page="page.current"
     :page-size="page.size"
     :total="page.total"
     :page-sizes="[1,10,50,100, 200, 300, 400]"
     layout="total, sizes, prev, pager, next, jumper"
     style="margin: -10px;"
     @size-change="handleSizeChange"
     @current-change="handleCurrentChange"
   >
   </el-pagination>
 </template>
 <edit-form
         :oneclass="oneclass"
         v-model="editFormVisible"
         @submit="getTableData"
 />

 <viewxqls-form
         :agentid="groupid"
         v-model="viewFormVisible"
         :pickerValue2="pickerValue2"
         :pickerValue3="pickerValue3"
         @submit="getTableData"
 />

 <viewSale-form
         :agentid="groupid"
         :saleid="saleid"
         v-model="viewSaleFormVisible"
         :pickerValue2="pickerValue2"
         :pickerValue3="pickerValue3"
         @submit="getTableData"
 />

</d2-container>
</template>
<script>
import * as memberService from "@/api/sys/member";
import * as agentService from "@/api/sys/agent";
import util from '@/libs/util.js'
import editForm from "../groupexpress/editForm";
import viewxqlsForm from "@/pages/tjpt/components/Turnover/viewxqlsForm";
import viewSaleForm from "@/pages/tjpt/components/Turnover/viewSaleForm";
export default {
name: "MembergglPage",
components: {editForm,viewxqlsForm,viewSaleForm},
data() {
 return {
   searchForm: {
     order_id:"",
     express_no:"",
     is_qr:""
   },
   loading: false,
   tableData: [],
   multipleSelection: [],
     dateRange: [],
     pickerOptions:{},
     typeOptions: [

         {
             value: "1",
             label: "已收货"
         },
       {
         value: "2",
         label: "待发货"
       }, {
         value: "3",
         label: "待收货"
       }
     ],

   saleOptions: [

     {
       value: "0",
       label: "未售卖"
     },
     {
       value: "1",
       label: "售卖中"
     }, {
       value: "2",
       label: "售卖成功"
     }
   ],

   page: {
     current: 1,
     size: 10,
     total: 0
   },
   sort: {
     prop: "",
     order: ""
   },
   groupid:'',
   saleid:'',
   pickerValue2:'',
   pickerValue3:'',
   viewFormVisible: false,
     oneclass: {},
   editFormVisible: false,
   viewSaleFormVisible: false,
     agentid:''
 };
},
mounted() {
 this.getTableData();
},
methods: {
   dateConversion(value) {
       if (value != null && value != "") {
           var d = new Date(value);
             var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
           //var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
           console.info("===========date=========" + date);
           return date;
       }else{
           return "";
       }
   },

 dateConversion2(value) {
   if (value != null && value != "") {
     var d = new Date(value);
    // var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
     var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
     console.info("===========date=========" + date);
     return date;
   }else{
     return "";
   }
 },
 getImgUrl2(row){
   return row.user_img_url;
 },
 aaaa(){
   window.open("https://www.kuaidi100.com/","_blank");
 },
 getImgUrl(row){
   var good_url=row.good_url;
   if(good_url.match(",")){
     var str = good_url.split(',');
     good_url=str[0];
   }

   return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+good_url;
 },
 handleExportFormSubmit() {
   window.location.href=encodeURI(process.env.VUE_APP_API+"/moblieapp/grouporderUsertoExcel?start_time="+ this.dateConversion(this.dateRange[0])+"&end_time="+this.dateConversion(this.dateRange[1])+"&order_id="+this.searchForm.order_id+"&is_qr="+this.searchForm.is_qr+"&is_win=1"+"&is_sale="+this.searchForm.is_sale);
 },
 getTableData() {
   let query = {
     pageIndex: this.page.current,
     pageSize: this.page.size,
     sortBy: this.sort.prop,
     is_win:'1',
     start_time2:this.dateConversion(this.dateRange[0]),
     end_time2:this.dateConversion(this.dateRange[1]),
     descending: this.sort.order === "descending",
     filter: this.searchForm
   };
   agentService.myGrouporderUserlist(query).then(data => {
     this.tableData = data.rows;
     this.page.total = data.totalCount;
   });
 },

 openViewForm2(agent){
   this.groupid = agent.sale_group_id+'';
   this.pickerValue2="";
   this.pickerValue3="";
   this.viewFormVisible = true;
   this.editFormVisible = false;
 },
 openViewForm3(agent){
   this.groupid = agent.amount;
   this.saleid=agent.id;
   this.pickerValue2="";
   this.pickerValue3="";
   this.viewSaleFormVisible = true;

 },
 handleSearchFormSubmit() {
   this.getTableData();
 },
 handleSearchFormReset() {
   this.$refs.searchForm.resetFields();
 },
 handleSelectionChange(val) {
   this.multipleSelection = val;
 },
 handleSortChange(val) {
   this.sort.prop = val.prop;
   this.sort.order = val.order;
   this.getTableData();
 },
 handleSizeChange(val) {
   this.page.size = val;
   this.getTableData();
 },
 handleCurrentChange(val) {
   this.page.current = val;
   this.getTableData();
 },
 openEditForm(oneclass) {
   this.oneclass = oneclass;
   this.editFormVisible = true;
   this.viewFormVisible = false;
 },

 del(oneclass) {
   this.$confirm("确认删除？", "确认信息", {
     distinguishCancelAndClose: true,
     confirmButtonText: "删除",
     cancelButtonText: "取消"
   }).then(() => {
     agentService.delIntegral({id:oneclass.id}).then(() => {
       this.getTableData();
     });
   });
 }
}
};
</script>
